import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import PaymentMethods, { PaymentMethodType } from '~/types/PaymentMethods';

export type BillingState = {
  paymentMethods: PaymentMethods;
  showCreditCardModal: boolean;
  isLoadingPaymentMethods: boolean;
  showChangePaymentModal: boolean;
  newPaymentType: Maybe<PaymentMethodType>;
  ccUpdatedNotification: boolean;
  changePaymentNotificationSuccess: boolean;
  changePaymentNotificationError: boolean;
  paymentProcessingError: string;
};

export const paymentMethodsInitialState: PaymentMethods = {
  achAccountNumberLast4: '',
  achAuthorized: false,
  blockedBilling: false,
  billingFrequency: 0,
  paymentCurrency: '',
  paymentThreshold: 0,
  paymentType: '',
  stripeAchSet: false,
  stripeAuthorized: false,
  stripeCcBrand: '',
  stripeCcExpMonth: 0,
  stripeCcExpYear: 0,
  stripeCcLast4: 0,
  stripeCreditCardSet: false,
  stripePublishableKey: '',
  stripeToken: '',
};

export const initialState: BillingState = {
  paymentMethods: paymentMethodsInitialState,
  showCreditCardModal: false,
  isLoadingPaymentMethods: true,
  showChangePaymentModal: false,
  newPaymentType: null,
  ccUpdatedNotification: false,
  changePaymentNotificationSuccess: false,
  changePaymentNotificationError: false,
  paymentProcessingError: '',
};

function reducer(state: BillingState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.BILLING_OPEN_CREDIT_CARD_MODAL:
      return {
        ...state,
        showCreditCardModal: true,
      };
    case ActionKeys.BILLING_CLOSE_CREDIT_CARD_MODAL:
      return {
        ...state,
        showCreditCardModal: false,
      };
    case ActionKeys.FETCH_PAYMENT_METHODS:
      return {
        ...state,
        isLoadingPaymentMethods: true,
      };
    case ActionKeys.FETCH_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        isLoadingPaymentMethods: false,
        paymentMethods: action.payload,
      };
    case ActionKeys.FETCH_PAYMENT_METHODS_ERROR:
      return {
        ...state,
        isLoadingPaymentMethods: false,
      };
    case ActionKeys.PAYMENT_METHOD_CHANGE_SUCCESS:
    case ActionKeys.PAYMENT_METHOD_CHANGE_ERROR:
      return {
        ...state,
        showChangePaymentModal: false,
      };
    case ActionKeys.BILLING_OPEN_CHANGE_PAYMENT_MODAL:
      return {
        ...state,
        showChangePaymentModal: true,
        newPaymentType: action.paymentType,
      };
    case ActionKeys.BILLING_CLOSE_CHANGE_PAYMENT_MODAL:
      return {
        ...state,
        showChangePaymentModal: false,
      };
    case ActionKeys.BILLING_CC_UPDATED_NOTIFICATION_SUCCESS:
      return {
        ...state,
        ccUpdatedNotification: true,
      };
    case ActionKeys.BILLING_CC_UPDATED_NOTIFICATION_HIDE:
      return {
        ...state,
        ccUpdatedNotification: false,
      };
    case ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        changePaymentNotificationSuccess: true,
      };
    case ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_ERROR:
      return {
        ...state,
        changePaymentNotificationError: true,
      };
    case ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_HIDE:
      return {
        ...state,
        changePaymentNotificationSuccess: false,
        changePaymentNotificationError: false,
      };
    case ActionKeys.BILLING_SET_PAYMENT_PROCESSING_ERROR:
      return {
        ...state,
        paymentProcessingError: action.paymentProcessingError,
      };
    case ActionKeys.BILLING_CLEAR_PAYMENT_PROCESSING_ERROR:
      return {
        ...state,
        paymentProcessingError: '',
      };
    default:
      return state;
  }
}

export default reducer;
